require('./../vendor/flatpickr/flatpickr.min.js');
require('./../vendor/flatpickr/l10n-it.js');
require('./index.js');